import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { auth } from './firebase-config';
import { swRegistration } from './services/swRegistration';

const container = document.getElementById('root');
const root = createRoot(container);

// Fonction pour gérer les erreurs globales
const ErrorBoundary = ({ children }) => {
  const [hasError, setHasError] = React.useState(false);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    const handleError = (error) => {
      console.error('Erreur capturée :', error);
      setError(error);
      setHasError(true);
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleError);

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleError);
    };
  }, []);

  if (hasError) {
    return (
      <div style={{
        padding: '20px',
        textAlign: 'center',
        fontFamily: 'sans-serif'
      }}>
        <h1>Une erreur est survenue</h1>
        <p>Veuillez rafraîchir la page ou réessayer plus tard.</p>
        {error && (
          <pre style={{
            margin: '20px',
            padding: '10px',
            background: '#f5f5f5',
            borderRadius: '4px',
            textAlign: 'left',
            overflow: 'auto'
          }}>
            {error.toString()}
          </pre>
        )}
      </div>
    );
  }

  return children;
};

// Enregistrer le service worker
//swRegistration.register().catch(error => {
 // console.error('Erreur lors de l\'enregistrement du service worker:', error);
//});

// S'assurer que Firebase est initialisé avant de rendre l'application
auth.onAuthStateChanged(() => {
  console.log('Firebase Auth initialisé');
  
  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </React.StrictMode>
  );
});

// Afficher un message de chargement initial
root.render(
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    fontFamily: 'sans-serif'
  }}>
    Chargement...
  </div>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

window.addEventListener('unhandledrejection', event => {
  console.error('Unhandled Promise Rejection:', event.reason);
  // Affichez une alerte ou un message plus convivial si nécessaire
  // alert(`Erreur non gérée : ${event.reason?.message || 'Une erreur de promesse s'est produite'}`);
}); 